// extracted by mini-css-extract-plugin
export default {"container":"q1uXsG","circled-container":"s_ubiP","circled":"nkq6em","bezel":"HiDoGG","circledBezel":"tjlLBY"};